var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { unitExcludeSelection, unitIncludeSelection } from "./monographUnit";
export function buildVerificationSelection(state, filter) {
    if (state.mode === "all") {
        return {
            matchFilter: filter,
            excludeIds: state.excludeIds.size
                ? Array.from(state.excludeIds)
                : undefined,
        };
    }
    return { includeIds: Array.from(state.includeIds) };
}
// Rows of the monograph listing are keyed by unitKey: an issue row carries its issue id too.
export function buildEnforcementSelection(state, filter) {
    if (state.mode === "all") {
        return __assign({ matchFilter: filter }, unitExcludeSelection(state.excludeIds));
    }
    return unitIncludeSelection(state.includeIds);
}
export function buildPeriodicalSelection(state, filter) {
    if (state.mode === "all") {
        return {
            matchFilter: filter,
            excludeIds: state.excludeIds.size
                ? Array.from(state.excludeIds)
                : undefined,
        };
    }
    return { includeIds: Array.from(state.includeIds) };
}
